import React from "react";
import "./MainLoginPage.css"; // Import the CSS file
import { useNavigate } from "react-router-dom";

function MainLoginPage() {
  const navigate = useNavigate();

  return (
    <div className="trf-container">
      {/* TRF Form Submission Section */}
      <div className="trf-card">
        <img
          className="trf-logo"
          src="https://crm-zeniximages.s3.ap-south-1.amazonaws.com/z+logo+(1).png"
          alt="ZeiniX Logo"
        />
        <hr></hr>
        <h1 className="trf-heading">Test Request Form Submission's</h1>
        <p className="trf-description">
          Submit your test request form directly by clicking the button below.
        </p>
        <button
          type="button"
          className="trf-button"
          onClick={() => window.location.href = "https://crm.zeinixlife.com/trf"}
        >
          Submit Test Request Form
        </button>
      </div>
  
      {/* Admin Login Link */}
      <div className="admin-link">
        <p>
          Are you an admin?{" "}
          <a href="/login">Login here</a>
        </p>
      </div>
    </div>
  );
}

export default MainLoginPage;
